// ─── studioTier — the single source of truth for "is this a Studio account?" ──
//
// Team Chat (the floating bubble, the app-wide notifier, and the sidebar nav
// item) is a STUDIO-only feature: a studio owner needs it to coordinate with
// their associates, and an associate needs it to reach the studio. Solo and
// Starter accounts have no team to chat with, so the whole feature is hidden.
//
// "Studio" = the studio owner (subscription_tier === 'studio') OR a studio
// associate (subscription_tier === 'team_member', set on a member's profile
// when they accept a Studio invite). Everyone else (solo, starter, trial,
// null) is NOT a studio.
//
// Keep this the ONLY place that encodes the tier strings so the three call
// sites (TeamChatFloater, useTeamChatNotifications, SidebarV2) stay in lockstep.

const STUDIO_TIERS = new Set(['studio', 'team_member'])

export function isStudioTier(tier) {
  return STUDIO_TIERS.has(tier)
}

export default isStudioTier
